import * as types from './types'

export const syncWishlistedProducts = (data) => ({
  type: types.SYNC_WISHLISTED_PRODUCTS,
  payload: data,
})

export const deleteWishlistedProduct = (product) => ({
  type: types.DELETE_WISHLISTED_PRODUCT,
  payload: product,
})

export const wishlistLoading = (details) => ({
  type: types.WISHLIST_LOADING,
  payload: details,
})